export class WorkDayRequest {
  constructor(workDay = {}) {
    this.day_of_week = workDay.dayOfTheWeek;
    this.opens_at = workDay.opensAt;
    this.closes_at = workDay.closesAt;
  }
}
